<template>
	<div :class="contentClasses" @click="onClick">
		<div class="tab-content">
			<div>
				<slot name="leftIcon">
					<FontAwesomeIcon
						v-if="leftIcon"
						:icon="leftIcon"
					/>
				</slot>
			</div>
			<div class="tab-label text-noselect"><slot></slot></div>
			<div>
				<slot name="rightIcon">
					<FontAwesomeIcon
						v-if="rightIcon"
						:icon="rightIcon"
					/>
				</slot>
			</div>
		</div>
		<div :class="indicatorClasses"><!-- intentionally empty --></div>
	</div>
</template>

<script>
export default {
	name: "Tab",
	emits: [ "select", ],
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: "",
		},
		leftIcon: {
			type: Array,
			default: () => undefined,
		},
		rightIcon: {
			type: Array,
			default: () => undefined,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		contentClasses() {
			return {
				tab: true,
				"tab--active": this.isActive,
				"tab--disabled": this.disabled,
			};
		},
		indicatorClasses() {
			return {
				"tab-indicator": true,
				"tab-indicator--active": this.isActive,
				"tab-indicator--disabled": this.disabled,
			};
		},
	},
	methods: {
		onClick() {
			if ( this.disabled ) {
				return;
			}
			this.$emit( "select", this.id );
		},
	},
};
</script>

<style lang="scss" scoped>
$tabFontColor--disabled: $color1-200;
$tabFontColor--inactive: $color1-400;
$tabFontColor--hover: $color1-500;
$tabBackgroundColor--hover: $color1-500;
$tabFontColor--active: $color2-500;
$tabBackgroundColor--active: $color2-500;

.tab {
	cursor: pointer;
	@include font-and-line-for(0);
	padding-top: .5rem;
	font-weight: 600;
	color: $tabFontColor--inactive;
}

.tab-indicator {
	height: .25rem;
	border-radius: .5rem .5rem 0 0;
	background: transparent;
}

.tab--active {
	color: $tabFontColor--active;
}

.tab--disabled {
	color: $tabFontColor--disabled;
	cursor: not-allowed;
}

.tab-indicator--active {
	background: $tabBackgroundColor--active;
}

.tab:hover {
	&:not(.tab--active):not(.tab--disabled) {
		color: $tabFontColor--hover;
	}

	.tab-indicator:not(.tab-indicator--active):not(.tab-indicator--disabled) {
		background: $tabBackgroundColor--hover;
	}

	.tab-indicator.tab-indicator--active {
		background: $tabBackgroundColor--active;
	}
}

.tab-label {
	white-space: nowrap;
	padding-bottom: .25rem;
	display: flex;
	align-items: center;
}

.tab-content {
	display: flex;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}

</style>
